export default {
  path: '/advisor',
  name: 'Advisor',
  component: () => import('../layout/advisor/Layout.vue'),
  redirect: '/advisor/beneficiaries',
  meta: {
    title: 'Addviseo',
  },
  children: [
    {
      path: 'beneficiaries',
      name: 'AdvisorBeneficiaries',
      component: () => import('../views/Advisor/Beneficiaries/Index.vue'),
      meta: {
        pageTitle: 'Portefeuille',
      },
      children: [
        {
          path: '',
          name: 'AdvisorBeneficiariesList',
          component: () => import('../views/Advisor/Beneficiaries/List.vue'),
        },
        {
          path: ':nanoid',
          name: 'AdvisorBeneficiariesSheet',
          component: () => import('../views/Advisor/Beneficiaries/Sheet.vue'),
        },
      ],
    },
    {
      path: 'offers-and-recos',
      name: 'AdvisorOffersAndRecos',
      component: () => import('../views/Advisor/OffersAndRecos/Index.vue'),
      meta: {
        pageTitle: 'Offres et recos',
      },
      children: [
        {
          path: '',
          name: 'AdvisorOffersAndRecosList',
          component: () => import('../views/Advisor/OffersAndRecos/List.vue'),
        },
      ],
    },
  ],
};
